module.exports = __webpack_public_path__ + "static/img/img17.25373399.png";